module.exports = __webpack_public_path__ + "static/img/Party-On.1e7e28b9.png";